import { useAppSelector, useAppDispatch } from '@/redux/hooks'
import { getDate } from '@/utils'
import { Button } from '@heroui/react'
import { useTheme } from '@/ui/theme'
import { setSelectedProcessID } from '@/redux/order/order-slice'
import { createSearchParams, Link } from 'react-router'
import { usePages } from '@/hooks'
import { useTranslation } from 'react-i18next'

export function ProcessSelectionPage() {
  const dispatch = useAppDispatch()
  const { t, i18n } = useTranslation()
  const { pages } = usePages()
  const theme = useTheme()

  const orderNumber = useAppSelector((store) => store.order.orderNumber)
  const email = useAppSelector((store) => store.order.email)

  const order = useAppSelector((store) => store.returnsApi.order.response)
  const processes = order.previous_return_processes ?? []

  const lineItems = order?.order?.line_items ?? []

  const noReturnableItems = lineItems.every((item) => {
    const nonRet = item.non_returnable_items?.reduce((acc, curr) => {
      return acc + (curr.quantity ?? 1)
    }, 0)
    return item.quantity === nonRet
  })

  return (
    <div>
      <main className="flex min-h-screen flex-col items-center justify-center p-8">
        <h4 className="mb-8 text-center text-3xl font-extrabold">
          {t('tracking_layout.your_return_from')} {orderNumber}
        </h4>
        <div className="space-y-4 pb-8">
          <h6 className="text-center text-xl font-extrabold text-gray-500">
            {noReturnableItems
              ? t('tracking_layout.see_order')
              : t('tracking_layout.start_new_return')}
          </h6>
          <Button
            as={Link}
            to={pages.ItemSelection}
            fullWidth
            variant="solid"
            radius="sm"
            size="lg"
            style={{
              backgroundColor: theme.colors.primary.main,
              color: theme.colors.primary.contrastText,
              borderRadius: theme.borderRadius
            }}
          >
            {noReturnableItems
              ? t('tracking_layout.see_order')
              : t(`tracking_layout.start_new_return`)}
          </Button>
        </div>
        <hr className="w-1/2" />
        <div className="space-y-5 pt-6">
          <h6 className="text-center text-xl font-extrabold text-gray-500">
            {t('tracking_layout.status_previous')}
          </h6>
          <div className="flex flex-col items-center gap-4">
            {processes.map((process, i) => {
              return (
                <Button
                  key={i}
                  as={Link}
                  to={{
                    pathname: pages.Tracking,
                    search: createSearchParams({
                      processId: process.process_id ?? '',
                      orderNumber: orderNumber ?? '',
                      email: email ?? '',
                      source: 'process_selection'
                    }).toString()
                  }}
                  onPress={() =>
                    dispatch(setSelectedProcessID(process.process_id))
                  }
                  fullWidth
                  variant="solid"
                  radius="sm"
                  size="lg"
                  style={{
                    backgroundColor: theme.colors.primary.main,
                    color: theme.colors.primary.contrastText,
                    borderRadius: theme.borderRadius
                  }}
                >
                  <p>
                    {t(`tracking_layout.return_process`)}
                    {getDate(process.started_at ?? '', i18n.language)}
                  </p>
                </Button>
              )
            })}
          </div>
        </div>
      </main>
    </div>
  )
}
